document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.trade-dropdown-toggle');
  const menu = document.querySelector('.trade-dropdown-menu');

  if (!toggle || !menu) return;

  document.body.appendChild(menu);
  menu.style.position = 'fixed';
  menu.style.zIndex = '1010';

  function positionMenu() {
    const rect = toggle.getBoundingClientRect();
    menu.style.top = rect.bottom + 4 + 'px';
    menu.style.left = rect.left + 'px';
  }

  function openDropdown() {
    positionMenu();
    toggle.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
  }

  function closeDropdown() {
    toggle.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
  }

  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    isExpanded ? closeDropdown() : openDropdown();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.trade-dropdown-wrapper') && !e.target.closest('.trade-dropdown-menu')) {
      closeDropdown();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDropdown();
      toggle.focus();
    }
  });

  menu.addEventListener('keydown', function (e) {
    const items = menu.querySelectorAll('.trade-dropdown-item');
    const currentIndex = Array.from(items).indexOf(document.activeElement);
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      items[currentIndex < items.length - 1 ? currentIndex + 1 : 0].focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      items[currentIndex > 0 ? currentIndex - 1 : items.length - 1].focus();
    }
  });
});
